import { Alert, Button, Typography } from '@mui/material';
import * as Yup from 'yup';
import { Field } from 'formik';

import { FormRowsDivider, InputField } from '../../../fields';

export const YaMetrikaIntegration = () => {
  const validate = (value: string, schema: Yup.AnySchema) => {
    try {
      schema.validateSync(value);
    } catch (error) {
      return (error as any).message;
    }
  };

  return (
    <>
      <FormRowsDivider sx={{ marginTop: '20px' }} />

      <Typography sx={{ fontWeight: 'bold', marginBottom: '12px' }}>Яндекс.Метрика</Typography>

      <Alert severity="info" variant="filled" sx={{ marginBottom: '24px' }}>
        Мы отправляем цели с идентификаторами <b>eg_game_open</b> при открытии игры и <b>eg_lead_send</b> при отправке
        заявки. <br />В Яндекс.Метрике перейдите в раздел «Настройка» (вкладка Цели) и нажмите кнопку «Добавить цель». В
        поле «Название» укажите имя создаваемой цели. Установите тип условия «JavaScript-событие». Укажите нужный
        идентификатор цели. Нажмите кнопку «Добавить цель» и сохраните изменения.
        Счетчик уже должен быть установлен на вашем сайте.
        <br />
        <br />
        <Button href="" target="_blank" sx={{ marginLeft: '-8px' }}>
          Подробнее
        </Button>
      </Alert>

      <Field
        name="campaign.yaMetrikaIntegration.counterId"
        component={InputField}
        label="Номер счетчика"
        placeholder="123456"
        className="form-field webhook-input"
        validate={(value: string) => validate(value, Yup.number().nullable())}
      />
    </>
  );
};
